/**
 * @generated SignedSource<<9aed122e1a4bd4aa9d1a14cebacc11f7>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type StartLessonSetInput = {
  lessonSetId: string;
};
export type LessonLibraryStartMutation$variables = {
  input: StartLessonSetInput;
  localDay: any;
};
export type LessonLibraryStartMutation$data = {
  readonly startLessonSet: {
    readonly day: number | null | undefined;
    readonly id: string;
    readonly startedAt: any | null | undefined;
  };
};
export type LessonLibraryStartMutation = {
  response: LessonLibraryStartMutation$data;
  variables: LessonLibraryStartMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "localDay"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "LessonSet",
    "kind": "LinkedField",
    "name": "startLessonSet",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "startedAt",
        "storageKey": null
      },
      {
        "alias": null,
        "args": [
          {
            "kind": "Variable",
            "name": "localDay",
            "variableName": "localDay"
          }
        ],
        "kind": "ScalarField",
        "name": "day",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "LessonLibraryStartMutation",
    "selections": (v1/*:: as any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "LessonLibraryStartMutation",
    "selections": (v1/*:: as any*/)
  },
  "params": {
    "cacheID": "01719827833c5e2e9fd8bcd729d1d9f8",
    "id": null,
    "metadata": {},
    "name": "LessonLibraryStartMutation",
    "operationKind": "mutation",
    "text": "mutation LessonLibraryStartMutation(\n  $input: StartLessonSetInput!\n  $localDay: NaiveDate!\n) {\n  startLessonSet(input: $input) {\n    id\n    startedAt\n    day(localDay: $localDay)\n  }\n}\n"
  }
};
})();

(node as any).hash = "1959fb956209bbf25eae04b124a0fce7";

export default node;
